export default "__VITE_ASSET__VSPKp418__"